<script>
export default {
  props: {
    lData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  created() {
    this.$store.dispatch('app/setLaravelData', this.lData);
    this.initInstantiateData();
  },
  methods: {
    initInstantiateData() {},
  },
};
</script>
